"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const description = schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "basic_health", code: "mental_health_review" })
    .tag({ vocab: "snomed", code: "401061005" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ description });
